export default __webpack_public_path__ + "static/media/Logo_white_h.ef15cedf.svg";